module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1_jp.eba4ea10ff72f30ccfcff78656f99511.png";